import { AlertTriangle } from 'lucide-react';

const DEFAULT_DISCLAIMER =
  'AI-generated and may be inaccurate. Cross-check with the verified resources below before acting.';

const AIDisclaimer = ({ text, className = '' }) => {
  const message = text || DEFAULT_DISCLAIMER;

  return (
    <p
      className={`mt-2 flex items-start gap-1.5 text-xs text-muted-foreground ${className}`.trim()}
      role="note"
    >
      <AlertTriangle
        className="h-3.5 w-3.5 mt-0.5 shrink-0"
        aria-hidden="true"
      />
      <span>{message}</span>
    </p>
  );
};

export default AIDisclaimer;
